import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { hideGallery } from 'Actions/PhotoGalleryActions';
import PhotoSwipeFn from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import sizeOf from 'Utils/sizeOf';

class PhotoSwipe extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		items: PropTypes.object.isRequired,
		options: PropTypes.object,
		onClose: PropTypes.func
	};

	componentDidMount = () => {
		if (this.props.isOpen) {
			let visibleItems = this.props.items[this.props.postId] || [];
			this.openPhotoSwipe(visibleItems, this.props.options);
		}
	};

	componentWillReceiveProps = (nextProps) => {
		let visibleItems = nextProps.items[nextProps.postId] || [];
		if (nextProps.isOpen) {
			if (!this.props.isOpen) {
				this.openPhotoSwipe(visibleItems, nextProps.options);
			} else {
				this.photoSwipe.items.length = 0;
				visibleItems.forEach((item) => {
					this.photoSwipe.items.push(item);
				});
				this.photoSwipe.invalidateCurrItems();
				this.photoSwipe.updateSize(true);
			}
		} else if (this.props.isOpen) {
			this.photoSwipe.close();
		}
	};

	componentWillUnmount = () => {
		if (this.photoSwipe) {
			this.photoSwipe.close();
		}
	};

	openPhotoSwipe = (items, options) => {
		let pswpElement = ReactDOM.findDOMNode(this);
		this.photoSwipe = new PhotoSwipeFn(pswpElement, PhotoSwipeUIDefault, items, options);
		this.photoSwipe.listen('close', this.handleClose);
		this.photoSwipe.listen('gettingData', (index, item) => {
			sizeOf(item.src, (width, height) => {
				item.w = width;
				item.h = height;
				this.photoSwipe.updateSize(true);
			});
		});
		this.photoSwipe.listen('imageLoadComplete', (index, item) => {
			this.photoSwipe.updateSize(true);
		});
		this.photoSwipe.init();
	};

	handleClose = () => {
		this.props.dispatch(hideGallery());
	};

	render() {
		return (
			<div className='pswp' tabIndex='-1' role='dialog' aria-hidden='true'>
				<div className='pswp__bg'/>
				<div className='pswp__scroll-wrap'>
					<div className='pswp__container'>
						<div className='pswp__item no-ad'/>
						<div className='pswp__item no-ad'/>
						<div className='pswp__item no-ad'/>
					</div>
					<div className='pswp__ui pswp__ui--hidden'>
						<div className='pswp__top-bar'>
							<div className='pswp__counter'/>
							<button className='pswp__button pswp__button--close'
									title='Close (Esc)'/>
							<button className='pswp__button pswp__button--share'
									title='Share'/>
							<button className='pswp__button pswp__button--fs'
									title='Toggle fullscreen'/>
							<button className='pswp__button pswp__button--zoom'
									title='Zoom in/out'/>
							<div className='pswp__preloader'>
								<div className='pswp__preloader__icn'>
									<div className='pswp__preloader__cut'>
										<div className='pswp__preloader__donut'/>
									</div>
								</div>
							</div>
						</div>
						<div
							className='pswp__share-modal pswp__share-modal--hidden pswp__single-tap'>
							<div className='pswp__share-tooltip'/>
						</div>
						<button className='pswp__button pswp__button--arrow--left'
								title='Previous (arrow left)'/>
						<button className='pswp__button pswp__button--arrow--right'
								title='Next (arrow right)'/>
						<div className='pswp__caption'>
							<div className='pswp__caption__center'/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		items: state.photogallery.items,
		postId: state.photogallery.postId,
		isOpen: state.photogallery.isOpen,
		options: state.photogallery.options
	};
}


export default connect(mapStateToProps)(PhotoSwipe);



// WEBPACK FOOTER //
// ./src/components/common/PhotoSwipe.js